var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',[_c('h1',{staticClass:"page-title uppercase mt-2"},[_vm._v("Plan de site")])]),_c('app-plan-de-site')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }